import { ApparelProduct, IGraphicGDM, iPatternData, PlacementTypes } from "./types/Graphics.t"

export interface PatternScaleCalculationProps {
    pdmModel: ApparelProduct
    componentID: PlacementTypes
    patternData: iPatternData
    graphic: IGraphicGDM
    dpi?: dpi
}

export type dpi = 72 | 300

const PatternScaleCalculation = (props: PatternScaleCalculationProps): iPatternData => {
    const dpi: dpi = props.dpi ?? 72

    const sourceWidth = props.graphic.product.find(
        product => product.productID === 'unisex-classic-tee'
    )?.placement.find(
        placement => placement.placementID === 'graphic_back'
    )?.position.width

    const targetWidth = props.graphic.product.find(
        product => product.productID === props.pdmModel
    )?.placement.find(
        placement => placement.placementID === props.componentID
    )?.position.width

    const multiplier = sourceWidth && targetWidth ? sourceWidth / targetWidth * 72 / dpi : 1

    props.patternData.width = Math.round(props.patternData.width * multiplier)
    props.patternData.height = Math.round(props.patternData.height * multiplier)

    return props.patternData
}

export default PatternScaleCalculation
